import styled from "styled-components";

interface ContainerModalProps {
  backgroundColor?: string;
  width?: string;
  padding?: string;
}

interface ButtonProps {
  color?: string;
  backgroundColor?: string;
}

export const ContainerModal = styled.div<ContainerModalProps>`
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
  width: ${(props) => props.width};
  text-align: center;
  @media (max-width: 1224px) {
    width: 320px;
  }
`;

export const Button = styled.button<ButtonProps>`
  color: #555555;
  background-color: transparent;
  border: none;
  font-size: 22px;
  font-weight: 300;
  line-height: 1;
  margin-right: 4px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
    color: #000000;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
